var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHornInactiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.6700439,31C36.4974365,27.8723145,31.755249,25,25,25h-7v-6h7 c10.4160156,0,16.0703125-6.8251953,18.5146484-10.8945312C43.6005859,7.9570312,44,8.0039062,44,8.2519531V31h2V8.2519531 C46,7.0097656,44.9873047,6,43.7177734,6c-0.7861328,0-1.5214844,0.4130859-1.9189453,1.0771484 C39.5732422,10.7832031,34.4316406,17,25,17h-7v-4c0-1.6542969-1.3457031-3-3-3H5c-1.6542969,0-3,1.3457031-3,3v18 c0,1.6542969,1.3457031,3,3,3h10c1.6542969,0,3-1.3457031,3-3v-4h7c5.0412598,0,8.8465576,1.7806396,11.6462402,4H39.6700439z  M16,31c0,0.5517578-0.4482422,1-1,1H5c-0.5517578,0-1-0.4482422-1-1V13c0-0.5517578,0.4482422-1,1-1h10 c0.5517578,0,1,0.4482422,1,1V31z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.7070312,34.7070312 45.2929688,33.2929688 40,38.5859375 34.7070312,33.2929688 33.2929688,34.7070312  38.5859375,40 33.2929688,45.2929688 34.7070312,46.7070312 40,41.4140625 45.2929688,46.7070312 46.7070312,45.2929688  41.4140625,40  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHornInactiveMedium);
export default __webpack_public_path__ + "static/media/horn-inactive--medium.b3359ce34c4bae001ead9b4b4ca92d1a.svg";
export { ForwardRef as ReactComponent };